<template>
  	<v-app>	  
		<Toolbar 
			title="Integração User Function" 
			class="hidden-print-only"
			v-if="!isPublic"
		/>
	
		<NavigationDrawer 
			class="hidden-print-only"
			v-if="!isPublic"
		/>

		<Loading v-if="validatingToken" />
		<Content v-else/>

		<Footer 
			yearCr="2019" 
			nameCr="User Function" 
		/>
	</v-app>
</template>

<script>
import axios from "axios"
import { baseApiUrl, userKey } from "@/global"
// import { createNamespacedHelpers } from 'vuex'
// const { mapState } = createNamespacedHelpers('parameters')
import { mapState } from "vuex"
import Toolbar from "@/components/templates/Toolbar"
import NavigationDrawer from "@/components/templates/NavigationDrawer"
import Content from "@/components/templates/Content"
import Footer from "@/components/templates/Footer"
import Loading from "@/components/templates/Loading"

export default {
	name: "App",
	components: { Toolbar, NavigationDrawer, Content, Footer, Loading },
	computed: {
		...mapState('parameters', ['isMenuVisible', 'user']),

		isPublic() {
			if (window.location.pathname.search('/public/') > -1) { return true }
			return false
		}		
	},
	data: function() {
		return {
			validatingToken: true,
		}
	},
	methods: {
		async validateToken() {
			this.validatingToken = true

			const json = localStorage.getItem(userKey)
			const userData = JSON.parse(json)
			// this.$store.commit('parameters/setUser', null)

			if(!userData && window.location.pathname.search('/public/') === -1) {
				this.validatingToken = false
				this.$router.push({ name: 'auth' })
				return
			}

			const res = await axios.post(`${baseApiUrl}/validateToken`, userData)
			
			if (res.data) {
				this.$store.commit('parameters/setUser', userData)
				
				if(this.$mq === 'xs' || this.$mq === 'sm') {
					this.$store.commit('parameters/toggleMenu', false)
				}
			} else if (window.location.pathname.search('/public/') === -1) {
				localStorage.removeItem(userKey)
				this.$router.push({ name: 'auth' })
			}

			this.validatingToken = false
		}
	},
	created() {
		this.validateToken()
	}
}
</script>

<style>
	* {
		font-family: "Lato", sans-serif;
	}

	/* Geral */
	body {
		margin: 0;
	}
    body .no-rounded { border-radius: 0px; }

	/* Forms */
	.v-input__slot {
		border-width: 1px!important;
	}
	.v-btn:focus {
		outline: none;
	}

	@media print {
		body { 
			overflow: auto;
			height: auto; 
		}
		.scroll-y {
			height: auto;
			overflow: visible;
		}
		.application--wrap > .v-content, .application--wrap > .v-footer { padding: 0!important; }
	}
</style>